import React, { Component } from "react";
import MainLayout from "../mainLayout/index";
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import DraggerIcon from "../icons/draggericon";
import CatEditIcon from "../icons/catediticon";
import PlusIcon from "../icons/plusicon";
import TextField from "../component/TextField";
import CheckBox from "../component/CheckBox";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Validation import
import SimpleReactValidator from "simple-react-validator";

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "../component/loader";
import Tablist from "./Tablist";
import commonImage from "../commonImage";
import { values } from "lodash";

let sub;
// fake data generator
const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class OTHEREVENTSCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      imagePreloader: false,
      base64: "",
      getAllTalkEventsCategoryDetails: [],
      getAllTalkEventsCategoryDocs: getItems(0),
      talkeventscategoryname: "",
      talkeventsdisplayname: "",
      talkeventscategorydescription: "",
      changeTalkEventsCategoryTitleName: false,
      id: "",
      loaderFlag: false,
      isDraggable: false,
      eventiveId:'',
      sponsorName:"",
      colorCode:'',
      showTags:true,
      showFilters:true,
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }
  
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      talkeventscategoryname: "",
      talkeventsdisplayname: "",
      talkeventscategorydescription: "",
      base64: "",
      id : "",
      changeTalkEventsCategoryTitleName: false,
      sponsorName:"",
      eventiveId:'',
      showTags:true,
      showFilters:true,
      isEdited: false
    });
    this.validator.hideMessages("");
  };

  componentDidMount = async () => {
    this.getAllTalkEventsCategory();
    this.gettalkeventscategory();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  handleChecked = (e) => {
    this.updateState({
      [e.target.name]: e.target.checked,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  gettalkeventscategory = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "otherEvent|category|getRefValue":
          this.setState(
            {
              getAllTalkEventsCategoryDetails: response.data,
              getAllTalkEventsCategoryDocs: response.data.docs,
              error: response.data.error,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "otherEvent|category|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState({
              addCatmodal: false,
              changeTalkEventsCategoryTitleName: false,
              loaderFlag: false
            },
            this.apiserve.success("Events Catagory updated successful.")
          );
          }
          this.getAllTalkEventsCategory();
          break;
        // case "otherEvent|category|remove":
        //   this.getAllTalkEventsCategory();
        //   break;
        case "otherEvent|category|changeOrder":
          break;
      }
    });
  };

  getAllTalkEventsCategory = () => {
    this.apiserve.sendevent("otherEvent|category|getRefValue", {});
  };

  onChangeFile(e) {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          file: file,
          // base64: reader.result
        },
        () => {
          const fileList = Math.round((file && file.size / 1024));
            if (fileList >= 2048) {        
              this.setState({
                errorMsg: true,
                errorMsgShow: 'Please upload a file smaller than 2 MB'           
               })
                return false;
            }
            if(file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg' ){
              setTimeout(() => {
                  this.imageUpload(file, event.target.result);

                },0)
          }else{
            this.setState({
              errorMsg: true,
              errorMsgShow: 'Please upload a file for PNG,JPG or JPEG'           
          })
          }
        }
      );
    };
  }

  imageUpload = (file, img) => {
    this.setState({ imagePreloader: true });

    var fileSet= commonImage(file, false, '', img);
    fileSet.then((value) => {
      this.updateState({
        base64: value,
        imagePreloader: false,
      });
    });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeTalkEventsCategoryTitleName) {
        let updateTalkEventsCategory = {
          name: this.state.talkeventscategoryname,
          description: this.state.talkeventscategorydescription,
          image: this.state.base64,
          displayName: this.state.talkeventsdisplayname,
          categoryId: this.state.id,
          eventiveId:this.state.eventiveId,
          sponsorName:this.state.sponsorName,
          colorCode:this.state.colorCode,
          showTags:this.state.showTags,
          showFilters:this.state.showFilters,
        };
        this.apiserve.sendevent(
          "otherEvent|category|update",
          updateTalkEventsCategory
        );
      } 
      // else {
      //   let data = {
      //     name: this.state.talkeventscategoryname,
      //     description: this.state.talkeventscategorydescription,
      //     image: this.state.base64,
      //     displayName: this.state.talkeventsdisplayname,
      //     id: this.state.id,
      //   };
      //   this.apiserve.sendevent("otherEvent|category|add", data);
      // }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editTalkEventsCategoryUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeTalkEventsCategoryTitleName: true,
      talkeventscategoryname: item.name,
      talkeventsdisplayname: item.displayName,
      talkeventscategorydescription: item.description,
      id: item._id,
      base64: item.image,
      eventiveId:item.eventiveId ? item.eventiveId : '',
      sponsorName:item.sponsorName ? item.sponsorName : '',
      colorCode: item.colorCode ? item.colorCode : '',
      showTags: item.showTags,
      showFilters: item.showFilters,
      isEdited: false
    });
    this.validator.hideMessages("");
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllTalkEventsCategoryDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        categoryId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("otherEvent|category|changeOrder", data);
    this.setState({ getAllTalkEventsCategoryDocs: arr });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const {
      getAllTalkEventsCategoryDocs,
      changeTalkEventsCategoryTitleName,
    } = this.state;
    return (
      <React.Fragment>
           <div className="right_side_wrapper">
            <Tablist active={3} ref={this.tablistRef} />
            <div className="cat_outer_content">
            <div className="category_add_edit category_column">
              <div className="category_header relative d_flex">
                <p>Institute Events</p>
                <p>Display Name</p>
                {/* <span className="add_icon d_flex" onClick={this.AddCategory}>
                  <FpgPlusIcon
                    width="16"
                    height="16"
                    color="#ffffff"
                    stroke="#4F4F4F"
                  />
                </span> */}
              </div>
              <div className="list_wrap striped_droppable_table">
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <ul {...provided.droppableProps} ref={provided.innerRef}>
                        {getAllTalkEventsCategoryDocs.map((item, index) => (
                          <Draggable
                            key={item._id}
                            draggableId={item._id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <li
                                className="pointer d_flex d_flex_align_center"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <span className="cat_drag d_flex">
                                  <DraggerIcon />
                                </span>
                                <div className="cat_name d_flex">
                                  <p className="">{item.name}</p>
                                  <p className="display_name">{item.displayName}</p>
                                </div>
                                <div className="action d_flex d_flex_align_center">
                                  <span
                                    className="cat_edit pointer"
                                    onClick={() =>
                                      this.editTalkEventsCategoryUser(item)
                                    }
                                  >
                                    <CatEditIcon />
                                  </span>
                                  {/* <span
                                    className="remove_cat pointer"
                                    onClick={() =>
                                      this.deleteTalkEventsCategoryUser(item)
                                    }
                                  >
                                    <FpgMinusIcon
                                      width="16"
                                      height="16"
                                      color="#4F4F4F"
                                    />
                                  </span> */}
                                </div>
                              </li>
                            )}
                          </Draggable>
                        ))}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
            </div>
          </div>
          <div
            className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
          >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner">
              <p className="cat_title text_center">
                {changeTalkEventsCategoryTitleName
                  ? "Edit Institute Events Category"
                  : "Institute Events Category"}
              </p>
              <form>
                <div className="field_row horizontal_field d_flex">
                  <label>Category Image</label>
                  <div className="cat_img_upload">
                    <div className="cat_img radius_50 absolute_loader">
                      {this.state.imagePreloader ? (
                        <Loader />
                      ) : (
                        <img
                          src={
                            this.state.base64
                              ? this.apiserve.imageUrl + this.state.base64
                              : '/images/image-placeholder.png'
                          }
                        />
                      )}

                      <div className="input_file">
                        <input
                          id="myInput"
                          type="file"
                          ref={(ref) => (this.upload = ref)}
                          style={{ display: "none" }}
                          onChange={this.onChangeFile.bind(this)}
                          accept=".png, .jpg, .jpeg"
                        />
                        <span
                          className="add_icon"
                          onClick={() => {
                            this.upload.click();
                          }}
                        >
                          <PlusIcon />
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="limit_text">2 MB Limit</span> 
                </div>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Category Name"
                    name="talkeventscategoryname"
                    value={this.state.talkeventscategoryname}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Talks & Events Category Name",
                      this.state.talkeventscategoryname,
                      "required"
                    )}
                  />
                </div>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Category Display Name"
                    name="talkeventsdisplayname"
                    value={this.state.talkeventsdisplayname}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Talks & Events Display Name",
                      this.state.talkeventsdisplayname,
                      "required"
                    )}
                  />
                </div>
                {/* <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Sponsor"
                      name="sponsorName"
                      value={this.state.sponsorName}
                      onChange={this.onInputChange}
                    />
                  </div> */}
                <div className="field_row horizontal_field d_flex">
                  <label>Category Description</label>
                  <div className="textarea_wrap">
                    <textarea
                      type="text"
                      rows="12"
                      name="talkeventscategorydescription"
                      value={this.state.talkeventscategorydescription}
                      onChange={this.onInputChange}
                    ></textarea>
                    <span style={{ color: "red" }}>
                      {this.validator.message(
                        "Talks & Events Category Description",
                        this.state.talkeventscategorydescription,
                        "required"
                      )}
                    </span>
                  </div>
                </div>
                {  
                <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Eventive ID",
                        this.state.eventiveId,
                        "required"
                      )}
                      // disable={this.state.changeTalkEventsCategoryTitleName ? false : true}
                    />
                  </div>}
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Color Code"
                      name="colorCode"
                      value={this.state.colorCode}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Color Code",
                        this.state.colorCode,
                        "required"
                      )}
                    />
                  </div>
                  <div className="field_row">
                    <CheckBox
                      label="Include In Tags"
                      type="checkbox"
                      id="showTags"
                      name="showTags"
                      checked={this.state.showTags}
                      onChange={(e) => this.handleChecked(e)}
                    />
                  </div>
                  <div className="field_row">
                    <CheckBox
                      label="Include In Filters"
                      type="checkbox"
                      id="showFilters"
                      name="showFilters"
                      checked={this.state.showFilters}
                      onChange={(e) => this.handleChecked(e)}
                    />
                  </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.CloseModal}>
                    CANCEL
                  </button>
                  <button
                    className={this.state.changeTalkEventsCategoryTitleName && !this.state.isEdited ? "disabled" : "active"}
                    disabled={this.state.changeTalkEventsCategoryTitleName && !this.state.isEdited}
                    onClick={(e) => this.submitFn(e)}
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default OTHEREVENTSCategory;
